var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header'),_c('Banner'),_c('nums'),_c('sixDiv'),_c('product'),_c('solutions'),_c('product-exa'),_c('BeforeCooperate'),_c('Comutio'),_c('DynamicInfo'),_c('contact'),_c('BottomNavs'),_c('Footer'),_c('Message'),_c('Loading'),_c('BottomFloat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }